// Lightweight loader for Google's Share-to-Classroom widget.
// Loads platform.js once and exposes a render() helper.
// Docs: https://developers.google.com/workspace/classroom/guides/sharebutton

let loadPromise = null;

export function loadClassroomScript() {
  if (loadPromise) return loadPromise;
  loadPromise = new Promise((resolve) => {
    if (typeof window === "undefined") return resolve(false);
    if (window.gapi && window.gapi.sharetoclassroom) return resolve(true);
    const existing = document.querySelector('script[data-google-classroom="1"]');
    if (existing) {
      existing.addEventListener("load", () => resolve(true), { once: true });
      return;
    }
    const s = document.createElement("script");
    s.src = "https://apis.google.com/js/platform.js";
    s.async = true;
    s.defer = true;
    s.setAttribute("data-google-classroom", "1");
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.head.appendChild(s);
  });
  return loadPromise;
}

// Force a re-render of a specific .g-sharetoclassroom element by id.
// Useful when the widget is added dynamically after platform.js has already loaded.
export async function renderClassroomButton(elementId) {
  const ok = await loadClassroomScript();
  if (!ok) return;
  try {
    const el = document.getElementById(elementId);
    if (!el) return;
    if (window.gapi?.sharetoclassroom?.render) {
      window.gapi.sharetoclassroom.render(el);
    }
  } catch {
    // platform.js auto-discovers on load; a failed manual render is non-fatal
  }
}
